import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { HeartIcon, TrashIcon } from "@heroicons/react/24/outline";
import { wishlistAPI, getErrorMessage } from "../services/api";
import toast from "react-hot-toast";

export default function WishlistPage() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    wishlistAPI.get().then((res) => setItems(res.data)).finally(() => setLoading(false));
  }, []);

  const remove = async (productId: string) => {
    try {
      await wishlistAPI.remove(productId);
      setItems((prev) => prev.filter((i) => i.product_id !== productId));
      toast.success("Removed from wishlist");
    } catch (err) {
      toast.error(getErrorMessage(err));
    }
  };

  return (
    <>
      <Helmet><title>Wishlist – Kushi Fashions</title></Helmet>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">My Wishlist</h1>

        {items.length === 0 && !loading ? (
          <div className="text-center py-20">
            <HeartIcon className="h-16 w-16 text-gray-200 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Your wishlist is empty</p>
            <Link to="/products" className="btn-primary mt-4 inline-block py-2.5 px-6">Browse Products</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((item) => (
              <div key={item.id} className="card group hover:shadow-md transition-shadow">
                <Link to={`/products/${item.product_id}`}>
                  <img
                    src={item.product_image || "https://via.placeholder.com/300x400/f9a8d4/ec4899?text=Dress"}
                    alt={item.product_name}
                    className="w-full h-56 object-cover rounded-t-xl"
                  />
                </Link>
                <div className="p-3">
                  <Link to={`/products/${item.product_id}`}>
                    <p className="font-medium text-gray-800 text-sm line-clamp-2 hover:text-primary-600">{item.product_name}</p>
                  </Link>
                  <p className="text-primary-600 font-bold mt-1">₹{Number(item.product_price).toLocaleString("en-IN")}</p>
                  <button
                    onClick={() => remove(item.product_id)}
                    className="mt-2 text-xs text-red-400 hover:text-red-600 flex items-center gap-1"
                  >
                    <TrashIcon className="h-3 w-3" /> Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
